import { render, staticRenderFns } from "./finance-template-object.vue?vue&type=template&id=4f4efcce&"
import script from "./finance-template-object.vue?vue&type=script&lang=js&"
export * from "./finance-template-object.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports